import {Grid, Box, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Check} from '@material-ui/icons';
import {LogoTextWhite} from 'components/icons/icons';
import {PSingleLine} from 'components/TypographyShortcuts';
import {useGetApplicationChecklist} from 'hooks';
import {useEffect, useState} from 'react';

const useStyles = makeStyles(theme => ({
    insert: {
        border: '1px solid lightgray',
        textAlign: 'center',
        margin: 'auto',
        paddingTop: '0.5em',
        maxWidth: '600px',
    },
    descriptionText: {
        color: theme.palette.primary.main,
        minWidth: '70%',
    },
}));

const itemDescriptionFees = [
    'We compile all of your paperwork exactly as the USCG evaluators want it',
    'We double check your application for errors',
    'Perfect Pay.gov fees included',
    'We submit your application and follow up with the USCG NMC on your behalf if needed',
];

const itemDescriptionNoFees = [
    'We compile all of your paperwork exactly as the USCG evaluators want it',
    'We double check your application for errors',
    'We submit your application and follow up with the USCG NMC on your behalf if needed',
];

const FocusApplication = ({applicationType}) => {
    const classes = useStyles();

    const {data: checkoffs} = useGetApplicationChecklist();

    const [price, setPrice] = useState();
    const [description, setDescription] = useState([]);

    useEffect(() => {
        if (
            (applicationType === 'original' &&
                checkoffs?.application_checklist?.original_fees === false) ||
            (applicationType === 'renewal' &&
                checkoffs?.application_checklist?.renewal_fees === false) ||
            (applicationType === 'upgrade' &&
                checkoffs?.application_checklist?.upgrade_fees === false)
        ) {
            setPrice('$199');
            setDescription(itemDescriptionNoFees);
        } else {
            setPrice('$299');
            setDescription(itemDescriptionFees);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationType, checkoffs]);
    return (
        <Box className={classes.insert}>
            <Grid container direction='column' alignItems='center'>
                <Grid item style={{marginBottom: '1em'}}>
                    <LogoTextWhite width='60%' />
                </Grid>
                <Grid item>
                    <Box className={classes.descriptionText}>
                        <Typography variant='h4'>Perfect Application</Typography>

                        <Grid
                            container
                            direction='column'
                            alignItems='flex-start'
                            style={{marginTop: '2em'}}
                        >
                            <Grid item xs={2}></Grid>
                            <Grid item xs={10}>
                                <PSingleLine
                                    style={{
                                        margin: '0 0 0 6.4em',
                                        textAlign: 'left',
                                    }}
                                >
                                    Includes:
                                </PSingleLine>
                            </Grid>

                            <Grid>
                                {description.map((item, index) => (
                                    <Grid container spacing={1} key={index}>
                                        <Grid item xs={2}>
                                            <Check />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={10}
                                            style={{textAlign: 'left'}}
                                        >
                                            <Typography>{item}</Typography>
                                        </Grid>
                                    </Grid>
                                ))}
                            </Grid>

                            <Grid item xs={12} style={{margin: '3em auto'}}>
                                <Typography
                                    fontWeight='fontWeightBold'
                                    variant='h6'
                                    style={{color: 'black'}}
                                >
                                    <strong>
                                        We handle everything and cover all USCG Fees
                                        for {price} per application{' '}
                                    </strong>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FocusApplication;
